import React from 'react';
import ReactDOM from 'react-dom/client';
import 'antd/dist/reset.css';
import './index.css';
import reportWebVitals from './reportWebVitals';
import { createApp } from './create_app';
import { Provider } from 'mobx-react';
import { MaintainSession } from 'utils/common';
import { ConfigProvider } from 'antd';
import viVN from 'antd/locale/vi_VN';

import { StyleProvider, legacyLogicalPropertiesTransformer } from '@ant-design/cssinjs';

MaintainSession();
const App = createApp();
const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <ConfigProvider
    locale={viVN}
    theme={{
      token: {
        // colorPrimary: '#a0d911',
        borderRadius: 2,
        fontSize: 13,
      },
    }}
  >
    <StyleProvider hashPriority="high" transformers={[legacyLogicalPropertiesTransformer]}>
      <Provider>
        <App />
      </Provider>
    </StyleProvider>
  </ConfigProvider>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
